<template>
    <playerList :type="'assessment'"></playerList>
</template>

<script>
    import playerList from "../components/newPlayerList";
    export default {
        name: "assessmentReport",
        components:{
            playerList
        }
    }
</script>
